export class Helpers {
    private static blobUrl: string = null;

    public static isSafariIOS(): boolean {
        // https://stackoverflow.com/questions/3007480/determine-if-user-navigated-from-mobile-safari
        const ua = window.navigator.userAgent;
        const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
        const webkit = !!ua.match(/WebKit/i);
        return iOS && webkit && !ua.match(/CriOS/i);
    }

    public static isInternetExplorer(): boolean {
        return (
            navigator.appName === "Microsoft Internet Explorer" ||
            !!(
                navigator.userAgent.match(/Trident/) ||
                navigator.userAgent.match(/rv:11/)
            )
        );
    }

    public static openBlobInNewTab(data: Blob): void {
        if (this.blobUrl) {
            window.URL.revokeObjectURL(this.blobUrl);
        }
        this.blobUrl = window.URL.createObjectURL(data);
        window.open(this.blobUrl, "_blank");
    }

    // safari on iOS 12 does not allow blobs to be saved. Blobs can only be saved by opening them in an other tab.
    // tabs must be opened by direct user interaction, they cannot be opened as a result of a network request
    public static async downloadBlob(
        dataGetter: () => BlobWithFileName | Promise<BlobWithFileName>,
        downloader: (filename: string, data: Blob) => void,
    ): Promise<void> {
        let popup: Window = null;
        if (this.isSafariIOS()) {
            popup = window.open("", "_blank");
            popup.document.title = "downloading...";
        }

        const { fileName, data } = await dataGetter();

        if (popup) {
            if (this.blobUrl) {
                window.URL.revokeObjectURL(this.blobUrl);
            }
            this.blobUrl = window.URL.createObjectURL(data);
            popup.location.href = this.blobUrl;
        } else {
            downloader(fileName, data);
        }
    }
}

interface BlobWithFileName {
    data: Blob;
    fileName: string;
}
